import config from 'universal-config';
import * as devData from './msa-search-hashes.dev';
import * as prodData from './msa-search-hashes.prod';

export const { MSA_SEARCH_HASHES } = config().env === 'development' || config().env === 'local' ? devData : prodData;
